export type CustomerPermission =
  | "accessContractPartner"
  | "editContractPartner"
  | "accessInvoiceSettings"
  | "editInvoiceSettings"
  | "deleteCustomer"
  | "editCustomer"
  | "accessInvoices"
  | "editMember"
  | "accessHosting"
  | "accessOrders"
  | "accessExtension"
  | "bookExtension"
  | "accessInvites"
  | "accessConversations";

export const customerPermissions = {
  accessContractPartner: ["owner", "member", "accountant"],
  editContractPartner: ["owner", "accountant"],
  accessInvoiceSettings: ["owner", "accountant"],
  editInvoiceSettings: ["owner", "accountant"],
  deleteCustomer: ["owner"],
  editCustomer: ["owner"],
  accessInvoices: ["owner", "accountant"],
  editMember: ["owner"],
  accessHosting: ["owner", "member"],
  accessOrders: ["owner", "member"],
  accessExtension: ["owner", "member", "accountant"],
  bookExtension: ["owner", "member"],
  accessInvites: ["owner"],
  accessConversations: ["owner", "accountant"],
};
